/**
 * @author lokendra.chouhan
 * @Date: 2022-07-08 10:24:17
 * @Last Modified by: lokendra
 * @Last Modified time: 2022-07-08 10:24:17
 */
import { bool, func, shape } from 'prop-types';

/**
 * @class ManipalcignaHeader
 */

const ManipalcignaHeaderProps = {
  isOnlyMerchandise: bool.isRequired,
  loggedIn: bool.isRequired,
  cart: shape({}).isRequired,
  history: shape({}).isRequired,
  handleLogout: func.isRequired,
  handleShowLogin: func.isRequired,
};

/**
 * @class PropelCorporateGiftingHeader
 */

const PropelCorporateGiftingHeaderProps = {
  isOnlyMerchandise: bool.isRequired,
  loggedIn: bool.isRequired,
  cart: shape({}).isRequired,
  history: shape({}).isRequired,
  handleLogout: func.isRequired,
  handleShowLogin: func.isRequired,
};

export {
  ManipalcignaHeaderProps,
  PropelCorporateGiftingHeaderProps,
};



// WEBPACK FOOTER //
// client/containers/HeaderContainer/manipalcignaHeaderDataHandler.js